var _path, _path2, _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 36,
    viewBox: "0 0 31 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 0.0625V10.7812C15.5 11.9996 15.984 13.168 16.8455 14.0295C17.707 14.891 18.8754 15.375 20.0938 15.375H30.8125V31.3438C30.8125 32.5621 30.3285 33.7305 29.467 34.592C28.6055 35.4535 27.4371 35.9375 26.2188 35.9375H15.5H4.78125C3.56291 35.9375 2.39447 35.4535 1.53298 34.592C0.671483 33.7305 0.1875 32.5621 0.1875 31.3438V4.65625C0.1875 3.43791 0.671483 2.26947 1.53298 1.40798C2.39447 0.546483 3.56291 0.0625 4.78125 0.0625H15.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5625 10.7812V0.828125L30.0469 12.3125H20.0938C19.6876 12.3125 19.2982 12.1512 19.011 11.864C18.7238 11.5768 18.5625 11.1874 18.5625 10.7812Z",
    fill: "#DACBF9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 21,
    width: 18,
    height: 3,
    fill: "#6C42C1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 27,
    width: 18,
    height: 3,
    fill: "#6C42C1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file-icon.ef9f9f6fce5056b40692f7f26d3ac267.svg";
export { ForwardRef as ReactComponent };